import { defineNamespace } from '../core';
import { en } from './en';
import { fr } from './fr';

export const common = defineNamespace('common', fr, en);
